import { render, staticRenderFns } from "./CursoVersionDescripcionCard.vue?vue&type=template&id=264fa1a8&"
import script from "./CursoVersionDescripcionCard.vue?vue&type=script&lang=js&"
export * from "./CursoVersionDescripcionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports